<template>
  <v-navigation-drawer dark absolute expand-on-hover permanent right>
    <v-list dense>
      <v-list-item @click="loadSummary()">
        <v-list-item-icon>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Summary</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="loadTable()">
        <v-list-item-icon>
          <v-icon>mdi-table-large</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Table</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "ResultsBar",
  props: {
    doc: {
      type: Object,
    },
  },
  computed: {
    filteredUsers() {
      // return this.doc
      //   ? this.doc.users.filter((item) => item.webrole == "user")
      //   : null;
      return this.doc ? this.doc.users : [];
    },
  },
  methods: {
    loadUser(val) {
      this.$emit("loadUser", val);
    },
    loadSummary(val) {
      this.$emit("loadSummary", val);
    },
    loadTable(val) {
      this.$emit("loadTable", val);
    },
  },
};
</script>
